import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';

const AnalyticsTracker = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    // Track page view when location changes
    const pageName = location.pathname.replace('/', '') || 'home';
    trackPageView(pageName);
  }, [location, trackPageView]);

  return null; // Este componente no renderiza nada
};

export default AnalyticsTracker; 